import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../utils/api';
import { toast } from 'react-toastify';
import { Eye, EyeOff } from 'lucide-react';
const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/auth/reset-password/${token}`, { password });
      toast.success('Password has been reset');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0E0A1F] text-white px-4">
      <div className="bg-[#1C1235] p-8 rounded-xl shadow-md w-full max-w-md text-white">
      <div className="flex justify-center mb-6">
          <img src="/Spark_01.png" alt="Sparks Logo" className="h-12" />
        </div>
        <h2 className="text-2xl font-bold text-center mb-2">Reset Password</h2>
        <p className="text-sm text-center mb-6 font-light">Enter your new password</p>

        <form onSubmit={handleReset} className="space-y-4">
        <div className="relative">
  <label className="text-sm block mb-1 font-light text-white">New Password</label>
  <input
    type={showPassword ? 'text' : 'password'}
    name="password"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    placeholder="Enter password"
    className="w-full p-3 pr-10 rounded bg-white text-black border border-[#3B2D5F]"
    required
  />
  <div
    className="absolute right-3 top-[65%]  -translate-y-1/2 cursor-pointer"
    onClick={() => setShowPassword((prev) => !prev)}
  >
    {showPassword ? (
      <EyeOff className="text-[#6D5BAF] w-5 h-5" />
    ) : (
      <Eye className="text-[#6D5BAF] w-5 h-5" />
    )}
  </div>
</div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded text-white font-semibold bg-[#6D5BAF] hover:bg-[#5a4aa5] transition"
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
